<template>
  <div :style="{ height: '100%' }" id="listener_windowframe">
    <iframe
      v-show="src != null"
      class="window_frame_host"
      ref="window"
      referrerpolicy="origin"
      :src="getSrc(component)"
      allow="camera; microphone; geolocation; clipboard-read; clipboard-write"
    />

    <!-- Dialog delle notifiche, usato per mostrare
         notifiche innescate dal modulo esterno -->
    <PopupNotifica
      v-if="dialog_notifiche"
      :notifiche="notifiche"
      :originalpath="original_path"
      @chiudi_popup="handleChiudiPopup"
    />

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import PopupNotifica from "@/components/NOTIFICHE/PopupNotifica.vue";

export default {
  name: "WindowFrame",
  components: { PopupNotifica },
  props: {
    component: {
      type: String,
      default: "",
    },
    input_args: {
      type: [Object, null],
      default: null,
    },
    override: {
      type: String,
      default: null,
    },
    route: {
      type: String,
      default: "/",
    },
    window_frame_overflow: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {
      base_origin: null,
      caricamento: false,
      dialog_notifiche: false,
      modules: null,
      notifiche: new Array(),
      original_path: null,
      src: null,
    };
  },
  beforeMount() {
    window.addEventListener("message", this.handleFrameEvent);
  },
  async mounted() {
    this.caricamento = true;
    let that = this;
    const endpoint = await (await fetch("/config.json")).json();
    this.modules = endpoint.config.modules;
    document
      .getElementById("listener_windowframe")
      .addEventListener("execute_post_event", this.executePostEvent);
    document
      .getElementById("listener_windowframe")
      .addEventListener("refresh_token", () => {
        that.postEvent("jwt", localStorage.user_token);
      });
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleFrameEvent);
  },
  methods: {
    getSrc(component) {
      if (this.override != null) {
        const url = new URL(this.override);
        this.base_origin = url.protocol + "//" + url.host;
      } else {
        if ((this.component || "").trim() == "") {
          this.src = null;
          return null;
        }
        if (!this.modules) {
          return;
        }
        const computed_host_name = `${this.modules.hostname_prefix}/${component}`;
        const virtual_host_name = (this.modules.resolve || {})[
          computed_host_name
        ];
        if (virtual_host_name) {
          this.base_origin = `${this.modules.protocol}://${virtual_host_name}`;
        } else {
          this.base_origin = `${this.modules.protocol}://${this.modules.hostname_prefix}/${component}`;
        }
      }
      if (this.route != "/") {
        if (this.input_args == null) {
          this.input_args = { landing_page: this.route };
        } else {
          this.input_args["landing_page"] = this.route;
        }
      }
      this.src =
        this.base_origin +
        "/" +
        (this.input_args
          ? "?q=" + encodeURIComponent(JSON.stringify(this.input_args))
          : "");
      return this.src;
    },
    handleChiudiPopup() {
      this.dialog_notifiche = false;
    },
    handleFrameEvent(event) {
      if (
        event.origin.replace("/" + this.component, "") !=
        this.base_origin.replace("/" + this.component, "")
      ) {
        return;
      }
      const event_data = JSON.parse(event.data);

      switch (event_data.event) {
        case "go_to_route": {
          this.$router.push(event_data.data);
          break;
        }
        case "esterno_to_esterno": {
          for (let field in event_data.data) {
            this.$store.state.basic_parameters[field] = event_data.data[field];
          }
          this.$router.push(event_data.data.rotta);
          break;
        }
        case "loaded": {
          this.caricamento = false;
          this.postEvent("jwt", localStorage.user_token);
          this.executePostEvent();
          this.$emit("loaded");
          break;
        }
        case "logout": {
          console.log("entrato errore");
          if (event_data.data == 401) {
            this.$handleUnauthorized();
          } else {
            this.$handleError(event_data);
          }
          break;
        }
        case "show_notifiche":
          /* Logica per chiamare le notifiche puntate su un
           * percorso che pertiene a un modulo esterno.
           * Ce n'è bisogno per esempio in QuickHR perché Alberto
           * chiede di aprire notifiche da qualsivoglia landing
           * page su quel componente. */
          this.notifiche = event_data.data.notifiche;
          this.full_path = event_data.data.fullPath;
          this.dialog_notifiche = true;
          break;
        case "switch_frame":
          this.$emit("update:input_args", event_data.data);
          this.$emit("update:component", event_data.data.cod_modulo_target);
          break;

        default:
          this.$emit(event_data.event, event_data.data);
          break;
      }
    },

    postEvent(event, data) {
      const message = JSON.stringify({
        event: event,
        data: data,
      });
      this.$refs.window.contentWindow.postMessage(message, this.base_origin);
    },

    executePostEvent() {
      const BASIC_PARAMETERS = {
        id: localStorage.id,
        nominativo: localStorage.nominativo,
        id_profilo: localStorage.id_profilo,
        id_modulo_selezionato: localStorage.id_modulo_selezionato,
        id_azienda: localStorage.id_azienda,
        db_name: localStorage.dbname,
        prefisso_utente: localStorage.prefisso_utente,
        auth_level: localStorage.auth_level,
      };

      if (this.$store.state.basic_parameters) {
        for (const field in this.$store.state.basic_parameters) {
          BASIC_PARAMETERS[field] = this.$store.state.basic_parameters[field];
        }
      }

      this.postEvent("basic_parameters", BASIC_PARAMETERS);
      this.$store.state.basic_parameters = {};
    },
  },
  watch: {
    route(new_route) {
      this.postEvent("changeroute", new_route);
    },
  },
};
</script>
<style scoped>
.window_frame_host {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  outline: none !important;
  padding: 0;
  border: none;
}
</style>